import {Button, Checkbox, Col, ControlLabel, Form, Row} from "react-bootstrap";
import { handleFieldChange } from "../../../../Utils";

import SelectWrap from "../../../../components/SelectWrap";
import FieldGroup from "../../../../components/FieldGroup";
import countries from "../../../../data/countries";
import React from "react";

class AdContentForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            network: [],
            campaign: [],
            site: [],
            country: [],
            groupBy: [],
            dateFrom: null,
            dateTo: null
        }

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleGroupByChange = this.handleGroupByChange.bind(this);
    }

    handleGroupByChange({ target }) {
        let groupBy = [ ...this.state.groupBy ];

        if(target.checked && !groupBy.includes(target.name)) groupBy = [ ...groupBy, target.name ];
        else groupBy = groupBy.filter((x) => x !== target.name)

        this.setState({ groupBy });
    }

    render() {
        return (
            <Form>
                <div style={{ marginBottom: '15px' }}>
                    <Row>
                        <Col lg={3}>
                            <FieldGroup
                                type="date"
                                name="dateFrom"
                                label="Date From:"
                                onChange={this.handleFieldChange}
                                value={this.state.dateFrom}
                            />
                        </Col>

                        <Col lg={3}>
                            <FieldGroup
                                type="date"
                                name="dateTo"
                                label="Date To:"
                                onChange={this.handleFieldChange}
                                value={this.state.dateTo}
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col lg={3}>
                            <SelectWrap
                                values={this.props.values.network}
                                label="Network:"
                                name="network"
                                onChange={this.handleFieldChange}
                                value={this.state.network}
                                multi
                            />
                        </Col>
                        <Col lg={3}>
                            <SelectWrap
                                values={this.props.values.campaign}
                                label="Campaign:"
                                name="campaign"
                                onChange={this.handleFieldChange}
                                value={this.state.campaign}
                                multi
                            />
                        </Col>
                        <Col lg={3}>
                            <SelectWrap
                                values={this.props.values.site}
                                label="Site:"
                                name="site"
                                onChange={this.handleFieldChange}
                                value={this.state.site}
                                multi
                            />
                        </Col>
                        <Col lg={3}>
                            <SelectWrap
                                values={countries}
                                label="Country:"
                                name="country"
                                onChange={this.handleFieldChange}
                                value={this.state.country}
                                multi
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col lg={12}>
                            <ControlLabel style={{ margin: '0' }}>Group By:</ControlLabel>

                            <Checkbox onChange={this.handleGroupByChange} name="date">Date</Checkbox>
                            <Checkbox onChange={this.handleGroupByChange} name="network">Network</Checkbox>
                            <Checkbox onChange={this.handleGroupByChange} name="campaign">Campaign</Checkbox>
                            <Checkbox onChange={this.handleGroupByChange} name="campaign_name">Campaign Name</Checkbox>
                            <Checkbox onChange={this.handleGroupByChange} name="country">Country</Checkbox>
                            <Checkbox onChange={this.handleGroupByChange} name="site">Site</Checkbox>
                        </Col>
                        <Col lg={12}>
                            <ControlLabel style={{ margin: '0' }}>Tonic Functions:</ControlLabel>

                            <Checkbox onChange={this.handleGroupByChange} name="keyword">Keyword</Checkbox>
                            <Checkbox onChange={this.handleGroupByChange} name="adtitle">Ad Title</Checkbox>
                        </Col>
                    </Row>

                    <div>
                        <Button onClick={() => this.props.loadReport(this.state)} style={{ marginRight: '5px' }} bsStyle={'primary'}>Load Report</Button>
                        <Button onClick={() => this.props.loadFilters(this.state, [ 'network', 'campaign' ])} style={{ marginRight: '5px' }} bsStyle={'primary'}>Load Filters</Button>
                        <Button onClick={() => this.props.loadFilters(this.state, [ 'site' ])} bsStyle={'primary'}>Load Sites</Button>
                    </div>
                </div>

                <div style={{ marginBottom: '15px' }}>{this.props.children}</div>
            </Form>
        )
    }
}

export default AdContentForm;


// WEBPACK FOOTER //
// ./src/scenes/AdContentArbitrage/components/AdContentForm/index.js